import { BaseError } from './BaseError';

export function Error500() {
  return (
    <BaseError status="500" title="Server Error">
      <p>There was an error processing your request.</p>
      <p>Please try again later.</p>
      <p>If the problem persists, please contact support.</p>
    </BaseError>
  );
}
